import React, { useState } from "react";
import { apiService } from "../../services/api";

const AppointmentsList = ({ appointments, onUpdate, onDelete }) => {
  const [sendingEmail, setSendingEmail] = useState(null);

  const handleSendEmail = async (appointmentId) => {
    setSendingEmail(appointmentId);
    try {
      const response = await apiService.sendAppointmentEmail(appointmentId);
      if (response.success) {
        alert('Email sent successfully!');
      }
    } catch (error) {
      alert('Error sending email: ' + error.message);
    } finally {
      setSendingEmail(null);
    }
  };

  const handleDelete = async (appointmentId) => {
    if (window.confirm('Are you sure you want to delete this appointment?')) {
      try {
        const response = await apiService.deleteAppointment(appointmentId);
        if (response.success) {
          onDelete(appointmentId);
          alert('Appointment deleted successfully!');
        }
      } catch (error) {
        alert('Error deleting appointment: ' + error.message);
      }
    }
  };

  const formatTime = (timeString) => {
    const [hours, minutes] = timeString.split(':');
    const hour = parseInt(hours);
    const ampm = hour >= 12 ? 'PM' : 'AM';
    const displayHour = hour % 12 || 12;
    return `${displayHour}:${minutes} ${ampm}`;
  };

  if (!appointments || appointments.length === 0) {
    return (
      <div className="text-center py-8">
        <p className="text-gray-500">No appointments scheduled yet.</p>
      </div>
    );
  }

  return (
    <div className="space-y-4">
      {appointments.map((appointment) => (
        <div key={appointment._id} className="bg-white p-4 rounded-lg shadow border">
          <div className="flex justify-between items-start">
            <div className="flex-1">
              <h4 className="font-semibold text-lg text-gray-800">
                {appointment.title}
              </h4>
              <p className="text-gray-600">{appointment.userName}</p>
              <p className="text-gray-500 text-sm">{appointment.email}</p>
              
              <div className="mt-2 grid grid-cols-1 md:grid-cols-3 gap-2 text-sm">
                <div>
                  <span className="font-medium">Date:</span>{' '}
                  {new Date(appointment.date).toLocaleDateString()}
                </div>
                <div>
                  <span className="font-medium">Time:</span>{' '}
                  {formatTime(appointment.time)}
                </div>
                <div>
                  <span className="font-medium">Duration:</span>{' '}
                  {appointment.duration} minutes
                </div>
              </div>

              {appointment.description && (
                <p className="mt-2 text-gray-600 text-sm">
                  {appointment.description}
                </p>
              )}
            </div>

            <div className="flex flex-col gap-2 ml-4">
              <button
                onClick={() => handleSendEmail(appointment._id)}
                disabled={sendingEmail === appointment._id}
                className="bg-green-600 text-white px-3 py-1 rounded text-sm hover:bg-green-700 disabled:opacity-50"
              >
                {sendingEmail === appointment._id ? 'Sending...' : 'Send Email'}
              </button>
              
              <button
                onClick={() => onUpdate(appointment)}
                className="bg-blue-600 text-white px-3 py-1 rounded text-sm hover:bg-blue-700"
              >
                Edit
              </button>
              
              <button
                onClick={() => handleDelete(appointment._id)}
                className="bg-red-600 text-white px-3 py-1 rounded text-sm hover:bg-red-700"
              >
                Delete
              </button>
            </div>
          </div>
        </div>
      ))}
    </div>
  );
};

export default AppointmentsList;